export const REVIEW_CARD_TYPE = {
  CREATE: 'create',
  MODIFY: 'modify',
  STATUS: 'status',
};

export default '';
